export class TreeViewImpl {
    constructor(treeModelProvider, helper, presenter, nodeSelectionEvent) {
        let that = this;
        that.helper = helper;
        that.treeModelProvider = treeModelProvider;
        that.presenter = presenter;
        that.nodeSelectionEvent = nodeSelectionEvent;
    }

    getTreeView() {
        return this.presenter.getTreeView();
    }

    selectNode(id) {
        let tree = this.getTreeView();
        let treeView = tree.data('kendoTreeView');
        if (!treeView)
            return null;
        treeView.expand(tree.find(".k-item").first());
        let dataSource = treeView.dataSource;
        let dataItem = dataSource.get(id);
        let node = treeView.findByUid(dataItem.uid);
        treeView.select(node);
        this.presenter.onListView()
    }

    getSelectedNode() {
        let tree = this.getTreeView();
        if (!tree.data('kendoTreeView'))
            return null;
        let selected = tree.data('kendoTreeView').select();
        return tree.data('kendoTreeView').dataItem(selected);
    }

    getCriteria() {
        let that = this;
        if (that.helper != null) {
            let criteria = {};
            criteria.expressions = [];
            let selectedNodeExpressions = that.helper.createSelectedNodeExpressions(that.getSelectedNode());
            if (selectedNodeExpressions)
                criteria.expressions.push(...selectedNodeExpressions);
            return criteria;
        }
        return null;
    }

    /**
     *
     * @param {ListScreenView} owner
     */
    drawTreeView(owner, callBack) {
        let that = this;

        that.treeModelProvider.getNodes((roots) => {
            let tree = this.getTreeView();
            tree.kendoTreeView({
                loadOnDemand: true,
                dataTextField: 'displayString',
                autoScroll: true,
                dataSource: new kendo.data.HierarchicalDataSource({
                    data: roots,
                    schema: {
                        model: {
                            children: 'items'
                        }
                    }
                }),
                select: e => {
                    setTimeout(() => {
                        that.nodeSelectionEvent();
                    })
                }
            });
            if (callBack)
                callBack();
        })

    }
}





